import { createContext, PropsWithChildren, useContext } from 'react';
import { SummaryPart, useArticle, useBook } from 'topwrite';

const PartContext = createContext<SummaryPart | null>(null);

export const PartProvider = ({ children }: PropsWithChildren<any>) => {
    const { summary } = useBook();
    const article = useArticle();
    const part = article ? summary.getArticlePart(article) : null;

    return <PartContext.Provider value={part}>
        {children}
    </PartContext.Provider>;
};

export default function usePart() {
    const part = useContext(PartContext);

    if (!part) {
        throw new Error('Part not found');
    }
    return part;
}
